import { useContext } from 'react';
import { GalleryContext } from '../context/GalleryContext';
import { getGalleryIdForApi } from '../galleryStorage';

/**
 * Gallery id for API paths: URL tenant from GalleryProvider when under `/g/:galleryId`,
 * else localStorage / dev env.
 */
export function useGalleryIdForApi() {
  const ctx = useContext(GalleryContext);
  if (ctx?.galleryId) {
    return ctx.galleryId;
  }
  return getGalleryIdForApi();
}
